import {
    SEO_TITLE_STROLLER_ADDQUESTION,
    STROLLER_ADDQUESTION_HEADING,
    STROLLER_SEND,
} from 'mk/autogenerated/translations/StrollerAddQuestionPage.79e491e4e471c3b7fce87b424b6a401d'
import { QuestionAddFormData, STROLLER_ADD_QUESTION_FORM_NAME } from 'mk2/apps/strollers/containers/StrollerAddQuestion/QuestionAddForm';
import { StrollerAddQuestion } from 'mk2/apps/strollers/containers/StrollerAddQuestion/StrollerAddQuestion';
import { strollerQuestionAddTrigger } from 'mk2/apps/strollers/containers/StrollerAddQuestion/StrollerAddQuestion.actions';
import saga from 'mk2/apps/strollers/containers/StrollerAddQuestion/StrollerAddQuestion.sagas';
import { strollersDetailUrl } from 'mk2/apps/strollers/urls';
import { SubmitButton } from 'mk2/components/forms/SubmitButton';
import { mkReduxFormMapDispatchToProps, mkReduxFormMapStateToProps } from 'mk2/decorators/mkReduxForm';
import { cachedInitialValues } from 'mk2/helpers/form';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import FormPage, { FormPageDispatchProps, FormPageStateProps } from 'mk2/pages/FormPage';
import { getRequestDeviceMobile, AppState } from 'mk2/reducers';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {
}

interface StateProps extends FormPageStateProps {
    isMobile: boolean;
    slug: string;
    initialValues: QuestionAddFormData;
}

interface DispatchProps extends FormPageDispatchProps {
    onSave(slug: string, values: QuestionAddFormData);
}

type RouteProps = RouteComponentProps<{ slug: string }>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class StrollerAddQuestionPage extends FormPage<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const slug = ownProps.match.params.slug;

            return {
                ...mkReduxFormMapStateToProps(STROLLER_ADD_QUESTION_FORM_NAME)(state),
                isMobile: getRequestDeviceMobile(state),
                slug,
                initialValues: cachedInitialValues(STROLLER_ADD_QUESTION_FORM_NAME, {
                    question: '',
                }),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            ...mkReduxFormMapDispatchToProps(STROLLER_ADD_QUESTION_FORM_NAME),
            onSave: strollerQuestionAddTrigger,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_STROLLER_ADDQUESTION;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <StrollerAddQuestion {...props} />
        );
    }

    public getMetaRobots(props: Props): string {
        return 'noindex,follow';
    }

    public getSubmitButton(props: Props): React.ReactElement {
        return (
            <SubmitButton label={STROLLER_SEND} formName={STROLLER_ADD_QUESTION_FORM_NAME} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return url(strollersDetailUrl, { slug: props.slug });
    }

    public getHeaderTitle(props: Props): string {
        return STROLLER_ADDQUESTION_HEADING;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectSaga('containers.strollers.strollerAddQuestion', saga);
    }
}
